<template>
  <div class="container-dba">
    <!-- 公共头部 -->
    <home-header></home-header>
    <!-- banner  -->
    <div class="banner-info"></div>
    <!-- 中间内容部分 -->
    <div class="edu-wrapper">
      <div class="meun">
        <div class="meun-right">
          <p class="right-title">项目背景</p>
          <p class="content-p">
            习近平总书记在十九大提出“加强社会心理服务体系建设，培育自
            尊自信、理性平和、积极向上的社会心态”。作为落实十九大精神的两
            项具体部署，“健康中国行动”和“社会心理服务体系建设试点工作”
            都需要相当数量的能在基层从事心理健康服务的人才。中国心理卫生协
            会根据社会发展趋势和市场需求，充分发挥行业协会的职责和使命，结
            合曾担任心理咨询师国家职业资格鉴定技术支持单位的工作经验，参照
            《国家职业教育改革实施方案》的指导意见，开展《心理咨询师专业技能
            培训》项目。</p>
          <p class="right-title">课程大纲</p>
          <h3>《心理咨询师专业技能培训》项目培训时长:192学时。</h3>
          <table class="tab-content">
            <tr>
              <td class="weight">类别</td>
              <td class="weight">详情</td>
            </tr>
            <tr>
              <td class="weight">基础理论 72学时</td>
              <td>
                包括普通心理学、社会心理学、发展心理学、变态与健康心理学、咨询心理学的基础知识和基本理论。了解和熟悉心理学基础知识和基本理论,心理咨询职业的现状与发展,行业前景与科研成果,心理咨询的主要方法与服务人群。
              </td>
            </tr>
            <tr>
              <td class="weight">操作技能60学时</td>
              <td>包括心理诊断技能、心理咨询技能、心理测验技能。
                了解并掌握生物心理社会的评估模式，掌握常用的心
                理测量工具，运用心理咨询的基本技术开展心理咨询实
                践服务，熟悉和掌握建立有效咨询关系、咨询效果评
                估、结束咨询关系的技术和方法，初步具备心理危机
                干预的能力。
              </td>
            </tr>
            <tr>
              <td class="weight">职业伦理12学时</td>
              <td>包括职业伦理与精神卫生法的学习。熟悉和遵守心理
                咨询伦理的原则和要求，熟悉并遵守心理咨询的工作
                范围。
              </td>
            </tr>
            <tr>
              <td class="weight">实操训练32学时</td>
              <td>包括心理评估和咨询技术的演练,以分组练习、现场
                督导的形式进行。了解心理咨询的主要流派与疗法，
                认知行为疗法、人本主义疗法、精神分析疗法、家庭
                治疗、积极心理学疗法、后现代心理学疗法、合理情
                绪疗法、危机干预技术等。
              </td>
            </tr>
            <tr>
              <td class="weight">实习见习12学时</td>
              <td>心理咨询机构或医院门诊的观摩体验。</td>
            </tr>
          </table>
          <p class="right-title">考核与证书</p>
          <h2 style="font-size: 18px;margin-top:20px;">考核要求</h2>
          <h3>考核分理论与操作技能、实践考核两部分。</h3>
          <p class="content-p">( 1 )理论和操作技能统一采用线上考核方式，学员完成全部课程学习方有资格参加心理咨询师专业技能培训考试。</p>
          <p class="content-p">( 2 )实践考核由学员提供个人成长报告( 2500字以上)。</p>
          <p class="right-title">证书</p>
          <p class="content-p">( 1
            )经考核合格，由中国心理卫生协会颁发《心理咨询师专业技能培训》合格证书。证书统一编号，由中国心理卫生协会网站提供查询。此证书表明持证人已经通过相关课程的培训考核，具备相应的专业知识和职业技能,可作为能力评价、考核、聘用和任职的参考，并优先申请中国心理卫生协会会员。</p>
          <img src="../../assets/images/xinli/zhengshu.png"/>
          <p class="right-title">培训详情</p>
          <h3>1.培训人群</h3>
          <p class="content-p">( 1 )具有心理学、教育学、医学、社会工作等相关专业背景毕业，专科以上学历(含专科)的人员。</p>
          <p class="content-p">( 2 )相关专业大学专科或本科在读的人员。</p>
          <h3>授课形式</h3>
          <p class="content-p">线上录播+直播课(疫情后会安排线下实操课)</p>
          <h3>课程费用</h3>
          <p class="content-p">4880元/人</p>
          <p class="content-p">费用包含培训费、考试管理费、论文审核费、证书费等。</p>
          <h3>报名方式</h3>
          <p class="content-p">报名咨询:张老师13161676101 ( 手机微信同号)</p>
          <div style="clear: both;"></div>
        </div>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: "EduData",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
  }
};
</script>
<style scoped>
/* .banner-info */

.banner-info {
  width: 100%;
  height: 200px;
  background: url(../../assets/images/banner002.png);
  background-size: 100% 100%;
}

.edu-wrapper {
  width: 95%;
  margin: 0 auto;
  margin-bottom: 50px;
}

.right-title {
  background: url(../../assets/images/pic1.png) no-repeat;
  background-size: 100% 100%;
  width: 212px;
  height: 69px;
  text-align: center;
  line-height: 56px;
  font-size: 32px;
  padding-left: 40px;
  margin-top: 25px;
  margin-bottom: 17px;
}

.meun-right img {
  width: 100%;
  margin: 20px 0;
}

.content-p {
  font-size: 32px;
  margin-top: 20px;
}

h3 {
  font-size: 32px;
  margin-top: 20px;
}

h1 {
  font-size: 34px;
  margin-top: 20px;
}

/*table*/
.tab-content {
  width: 100%;
  margin-top: 20px;
  border: none;
  border-radius: 5px;
}

.weight {
  font-weight: bold;
}

.tab-content tr {
  height: 40px;
  line-height: 30px
}

.tab-content tr td:first-child {
  width: 80px;
}

.tab-content tr td {
  padding: 3px 5px;
  text-align: center;
  border: 1px solid rgba(231, 138, 47, 1);
  font-size: 28px;
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/education/entrepreneursPage.vue